export default __webpack_public_path__ + "static/media/course _certificate.d2cd1958.png";